import React from "react";
import ProjectBlocksArrayEditor from "./ProjectBlocksArrayEditor";

export default function ProjectBlocksContainerEditor({
                                                  title = "Blocks",

                                                  // Simple API
                                                  value,
                                                  onChange,

                                                  // Existing API
                                                  container,
                                                  path,
                                                  updateAtPath,
                                              }) {

    const data = container ?? value ?? { blocks: [] };

    const blocks = data.blocks || [];

    const setBlocks = (nextBlocks) => {

        if (onChange) {
            onChange({
                ...data,
                blocks: nextBlocks,
            });
            return;
        }

        if (updateAtPath) {
            updateAtPath([...path, "blocks"], nextBlocks);
        }

    };

    return (
        <details className="border rounded-md bg-white" open={false}>
            <summary className="cursor-pointer p-4 font-semibold">
                {title}
            </summary>

            <div className="p-4">
                <ProjectBlocksArrayEditor
                    blocks={blocks}
                    onChange={setBlocks}
                />
            </div>
        </details>
    );
}